module.exports = __webpack_public_path__ + "img/SKMA_rules8.c55c1f1c.png";